export * from './auth';
export { subscribeToUnauthorized } from './authEvents';
// `emitUnauthorized` stays internal — it is ours to fire, not a caller's. The handler below is
// the opposite: a caller supplies it and we call it.
export {
  setAuthFailureHandler,
  resetAuthFailureHandler,
  type AuthFailureHandler,
  type AuthFailureReason,
} from './authFailure';
